import Button from '../../Buttons';
import InputField from '../../Form/InputField';
import SelectField from '../../Form/SelectField';
import Icon from '../../Icon';
import Section from '../Section';
import { FC, FormEvent } from 'react';

type Props = {
	states: { value: string; label: string }[];
	cities: { value: string; label: string }[];
	search: string;
	setSearch: (value: string) => void;
	selectedState: string;
	setSelectedState: (value: string) => void;
	selectedCity: string;
	setSelectedCity: (value: string) => void;
	locationDisabled: boolean;
	showFilterButton?: boolean;
	onSearch: (e: FormEvent<HTMLFormElement>) => void;
	onFilterButtonPress: () => void;
};

const TopSection: FC<Props> = ({
	cities,
	states,
	search,
	setSearch,
	selectedState,
	setSelectedState,
	selectedCity,
	setSelectedCity,
	locationDisabled,
	showFilterButton = true,
	onSearch,
	onFilterButtonPress,
}) => {
	return (
		<div className="container pt-24 pb-32 md:pb-48 md:pt-8" id="busca">
			<form className="w-full flex flex-col gap-12 md:gap-8" onSubmit={onSearch}>
				<div className="flex flex-col md:flex-row md:items-end gap-12 w-full">
					<InputField
						label="Busque sua vaga"
						placeholder="Busque por vaga..."
						leftIcon="search"
						className="w-full md:w-auto md:min-w-[210px] my-0 text-[2.2rem] flex-grow"
						inputProps={{
							className: 'h-[5rem] w-full',
						}}
						onChange={e => {
							setSearch(e.target.value);
						}}
						value={search}
					/>
					<SelectField
						leftIcon="location"
						label="Estado"
						className="w-full md:w-auto flex-grow"
						inputProps={{
							className: 'h-[5rem] min-w-[210px]',
						}}
						disabled={locationDisabled}
						setValue={setSelectedState as any}
						value={selectedState}
						initialValue={selectedState}
						options={states}
					/>

					<SelectField
						leftIcon="location"
						label="Cidade"
						className="my-0 w-full md:w-auto flex-grow"
						inputProps={{
							className: 'h-[5rem] min-w-[210px]',
						}}
						disabled={!selectedState || !cities.length || locationDisabled}
						setValue={setSelectedCity as any}
						value={selectedCity}
						initialValue={selectedCity}
						options={cities}
					/>
					<Button variant="primary" size="gigantic" type="submit" className="h-[5rem] text-[2.2rem] mt-8 md:mt-0">
						Buscar
					</Button>
				</div>

				{showFilterButton ? <Button variant="secondary" size="gigantic" role="button" className="h-[5rem] md:hidden" onClick={onFilterButtonPress}>
					<Icon name="filter" />
					Filtros
				</Button> : null}
			</form>
		</div>
	);
};

export default TopSection;
